import { Component, Prop, Vue } from "vue-property-decorator";
import { ContentModuleModel } from "../models";
import { productConfiguratorStore as store } from "./../store";

@Component
export default class ContentModule extends Vue {
    protected expanded: boolean = false;
    protected backgroundColor: object = {} as object;
    protected fadeColor: object = {} as object;

    @Prop()
    protected vm!: ContentModuleModel;

    protected created() {
        // Sets background/fade-color depending on Backoffice property
        if (this.vm.backgroundColor) {
            this.backgroundColor = { "background-color": this.vm.backgroundColor };
            this.fadeColor = {
                background: `linear-gradient(0deg, ${this.vm.backgroundColor} 0%, rgba(255,255,255,0) 100%)`
            };
        }

        if (this.vm.borderColor) {
            if (this.vm.backgroundColor) {
                this.backgroundColor = { "background-color": this.vm.backgroundColor, "border": "1px solid" + this.vm.borderColor };
            } else {
                this.backgroundColor = { border: "1px solid" + this.vm.borderColor };
            }
        }
    }

    private toggleReadMore() {
        this.expanded = !this.expanded;
    }

    private get getBtnText() {
        return this.expanded ? store.translations.readLess : store.translations.readMore;
    }

    private get showReadMore() {
        return this.vm.contentReadMore;
    }

    get propertyModelValues() {
        return store.propertyModelValues;
    }

    get content() {
        let content: string = this.vm.content;
        this.propertyModelValues.forEach(propertyValue => content = content.replace(`[${propertyValue.key}]`, propertyValue.value !== undefined && propertyValue.value !== null ? propertyValue.value : ""));
        return content;
    }

    get contentReadMore() {
        let contentReadMore: string = this.vm.contentReadMore;
        this.propertyModelValues.forEach(propertyValue => contentReadMore = contentReadMore.replace(`[${propertyValue.key}]`, propertyValue.value ? propertyValue.value : ""));
        return contentReadMore;
    }
}
